import _ from 'underscore';

function buildQueryParamString(params) {
  const filteredPairs = _.omit(
    params,
    value => !(value) || ((typeof value === 'string') && value.trim().length === 0),
  );
  return Object.entries(filteredPairs)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}

export function buildUrl(baseUrl, params) {
  if (!(typeof baseUrl === 'string') || !_.isObject(params)) {
    return '';
  }

  const queryParams = buildQueryParamString(params);
  let joinSymbol = '';
  if (queryParams.length) {
    joinSymbol = baseUrl.indexOf('?') !== -1 ? '&' : '?';
  }

  return `${baseUrl}${joinSymbol}${queryParams}`;
}

export function getContextParams(context) {
  const returnParams = {};
  if (!context) return returnParams;
  const paramMap = {
    pdpServer: 'pdpserver',
    shoppingMode: '_shoppingMode',
    regionCode: '_regionCode',
    currencyCode: 'currencyCode',
    customerState: '_customerState',
    deviceType: '_deviceType',
  };

  Object.keys(paramMap).forEach((key) => {
    const value = context[key];
    if (value) {
      returnParams[paramMap[key]] = context[key];
    }
  });

  return returnParams;
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/UrlUtil.js